import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import type { ReactNode } from 'react';

interface Props {
  /** Title shown after the brand pipe. */
  subtitle: string;
  /** Optional buttons that appear on the right side of the header. */
  actions?: ReactNode;
}

export default function AppHeader({ subtitle, actions }: Props) {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="header">
      <div className="header-left">
        <span
          className="brand"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          Hensley Heritage
        </span>
        <div className="header-pipe" />
        <span className="header-sub">{subtitle}</span>
        <div className="header-nav" style={{ marginLeft: 12 }}>
          <NavLink to="/" end className={navLinkClass}>
            Tracker
          </NavLink>
          <NavLink to="/dashboard" className={navLinkClass}>
            Dashboard
          </NavLink>
          <NavLink to="/compare" className={navLinkClass}>
            Compare
          </NavLink>
          <NavLink to="/ingredients" className={navLinkClass}>
            Ingredients
          </NavLink>
          <NavLink to="/settings" className={navLinkClass}>
            Settings
          </NavLink>
        </div>
      </div>
      <div className="header-right">
        {actions}
        <button className="btn btn-ghost btn-sm" onClick={() => signOut()}>
          Sign out
        </button>
      </div>
    </div>
  );
}

function navLinkClass({ isActive }: { isActive: boolean }): string {
  return 'header-nav-link' + (isActive ? ' active' : '');
}
